import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 md:py-32 bg-white border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <span className="font-mono-nw text-xs tracking-[0.25em] uppercase text-[#002DFF]">
            Client outcomes
          </span>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Teams that scaled
            <br />
            with NovaWorks
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white p-8 md:p-10 flex flex-col"
            >
              <span className="font-display font-black text-5xl text-[#002DFF] leading-none">“</span>
              <blockquote className="mt-4 text-lg leading-relaxed text-[#0A0A0A] flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#E5E5E5]">
                <div className="font-bold text-sm">{t.name}</div>
                <div className="text-xs uppercase tracking-[0.15em] text-[#525252] mt-1">
                  {t.company}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
